export const MEL_ORD_HELP = {
  screenId: 'mel-ord',
  label: 'Pedidos',
  navPath: 'MercadoLibre → Pedidos',
  keywords: ['pedidos', 'ordenes', 'ventas', 'envio', 'etiqueta', 'mercado libre', 'mercadolibre'],
  status: 'draft',
  summary: 'Listado y consulta de pedidos recibidos en MercadoLibre.',
  sidebarItems: [
    {
      id: 'mel-orders',
      screenId: 'mel-ord',
      label: 'Pedidos de MercadoLibre',
      description: 'Consultar pedidos, ver detalle de comprador, artículos y pagos, e imprimir etiqueta de envío.',
      detail: {
        sections: [
          {
            title: 'Listado de pedidos',
            text: 'La pantalla principal muestra los últimos pedidos con su estado, fecha, total y cantidad de artículos. Podés filtrar por estado (Pagado, Confirmado, Enviado, Entregado, Cancelado).',
          },
          {
            title: 'Detalle del pedido',
            text: 'Al hacer clic en un pedido ves la información completa: datos del comprador, artículos comprados, pagos realizados y datos del envío.',
          },
          {
            title: 'Etiqueta de envío',
            text: 'Si el pedido tiene un envío asociado, podés imprimir la etiqueta de envío de Mercado Envíos en PDF.',
          },
        ],
      },
    },
  ],
}
